<template>
    <div>
      <div class="card">
        <div class="card-header">
            <div class="col-md-12">
              <ol class="breadcrumb breadcrumb-card-header pull-left">
                  <li class="breadcrumb-item">
                    <a href="javascript:void(0);" @click="backParent">Inventory Transfer</a>
                  </li>
                  <li class="breadcrumb-item active">
                      <span v-if="inventory.id === null">New</span>
                      <span v-else>
                        {{ inventory.transfer_no }}
                      </span>
                  </li>
              </ol>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group row">
                    <label for="transfer_date" class="col-sm-3 col-form-label text-left">Date</label>
                    <div class="col-sm-9">
                        <datetime v-model="inventory.transfer_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                    </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group row">
                    <label for="warehouse_origin" class="col-sm-3 col-form-label text-left">Origin:</label>
                    <div class="col-sm-9">
                        <select v-model="inventory.warehouse_origin" class="form-control" @change="setOrigin">
                            <option v-for="w in warehouseList" :key="w.warehouse_no" :value="w.warehouse_no">{{ w.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="warehouse_to" class="col-sm-3 col-form-label text-left">To:</label>
                    <div class="col-sm-9">
                        <select v-model="inventory.warehouse_to" class="form-control" @change="setTo">
                            <option v-for="w in warehouseList" :key="w.warehouse_no" :value="w.warehouse_no">{{ w.name }}</option>
                        </select>
                    </div>
                </div>
                <!-- <button data-toggle="modal" data-target="#modalInventoryTransfer" data-backdrop="static" data-keyboard="false" type="button" class="btn btn-outline-primary btn-sm" ><i class="fa fa-search" aria-hidden="true"></i></button> -->
              </div>
              <div class="col-md-6">
                <div class="form-group row">
                  <label for="company_origin" class="col-sm-3 col-form-label text-left">Company Origin</label>
                  <div class="col-sm-9">
                    <select v-model="inventory.company_origin" class="form-control">
                      <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="company_to" class="col-sm-3 col-form-label text-left">Company To</label>
                  <div class="col-sm-9">
                    <select v-model="inventory.company_to" class="form-control">
                      <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="notes" class="col-sm-3 col-form-label text-left">Notes</label>
                  <div class="col-sm-9">
                    <textarea rows="5" class="form-control" v-model="inventory.notes"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <table class="table table-sm table-item table-striped">
                  <thead>
                    <th>Product No.</th>
                    <th>Product</th>
                    <th>Qty</th>
                    <th>UoM</th>
                    <th>Price</th>
                    <th>#</th>
                  </thead>
                  <tbody>
                    <tr v-for="(p, index) in getDetail" :key="p.id">
                      <td>
                        <v-select :options="productselect" :reduce="product => product.meta.code" label="product" v-model="p.product_no" @input="setProduct(index)" :disabled="inventory.lock"/>
                      </td>
                      <td><input type="text" v-model="p.product" class="form-control" disabled="disabled"></td>
                      <td><input type="text" v-model="p.qty" class="form-control" /></td>
                      <td>
                        <select v-model="p.uom_id" class="form-control" :disabled="inventory.lock">
                          <option v-for="u in p.uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                        </select>
                      </td>
                      <td>{{ p.amount | currency }}</td>
                      <td>
                        <button type="button" class="btn btn-sm btn-danger" @click="remove(p.id)"> <i class="fa fa-trash"></i></button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span @click="addLine" style="color:blue; cursor: pointer">Add Line</span>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
        </div>
        <div class="card-footer">
         <button class="btn btn-sm btn-success pull-right" @click="saveInventory" v-if="inventory.id === null"><i class="fa fa-sign-out"></i> Transfer</button>
         <button class="btn btn-sm btn-primary pull-right" @click="updateInventory" v-else><i class="fa fa-save"></i> Update</button>
         <!-- <button class="btn btn-success btn-sm pull-right" @click="approveInventory" v-show="inventory.id !== null">Approve</button> -->
        </div>
      </div>
      <PurchasingProductModal :idDetail="idDetail" @selectProduct="selectProduct"/>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import PurchasingProductModal from '@/components/purchasing/PurchasingProductModal.vue'
import { productUrl, inventoryUrl, getHeader } from '../../config'

export default {
  name: 'InventoryForm',
  props: ['inventory'],
  components: {
    PurchasingProductModal
  },
  data () {
    return {
      idDetail: null,
      idPDetail: null,
      product: {
        product_no: null,
        uom_id: null
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      warehouseList: state => state.warehouses.warehouseList,
      uomList: state => state.uom.uomList,
      branchList: state => state.branches.branchList,
      companyList: state => state.companies.companyList,
      productListSelect: state => state.products.productListSelect
    }),
    productselect: function () {
      var loop = []
      var array = this.productListSelect
      for (var x = 0; x < array.length; x++) {
        var obj = {
          product: array[x].product_no + ' - ' + array[x].product_name,
          meta: {
            code: array[x].product_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    getDetail: function () {
      return this.inventory.details.filter(d => d.type === 'to')
    },
    purchasingDetail: function () {
      return this.purchasing.details
    }
  },
  methods: {
    async setProduct (index) {
      var detail = this.getDetail[index]
      var product = this.productListSelect.find(d => d.product_no === detail.product_no)
      console.log('Product: ')
      console.log(product)
      detail.product_no = product.product_no
      detail.product = product.product_name
      detail.canBarcode = product.canBarcode
      var body = {
        product_no: detail.product_no
      }
      await axios.post(productUrl + '/uom/list', body, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.data)
          detail.uomList = response.data.data
          this.inventory.details[index].uom_id = product.uom_id
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    setOrigin () {
      var wh = this.warehouseList.find(d => d.warehouse_no === this.inventory.warehouse_origin)
      this.inventory.company_origin = wh ? wh.company_no : null
    },
    setTo () {
      var wh = this.warehouseList.find(d => d.warehouse_no === this.inventory.warehouse_to)
      this.inventory.company_to = wh ? wh.company_no : null
    },
    remove: function (id) {
      var detail = this.inventory.details.find(d => d.id === id)
      var index = this.inventory.details.findIndex(d => d.id === id)
      if (detail.state === 'create') {
        this.inventory.details.splice(index, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(inventoryUrl + '/transfer/detail/' + detail.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
              .then(response => {
                this.inventory.details.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
                this.$swal(
                  'Error',
                  '<pre>' + error.response.data + '</pre>',
                  'error'
                )
              })
          }
        })
      }
    },
    setIdDetail: function (id) {
      this.idDetail = id
      this.$store.dispatch('getProductList')
    },
    selectProduct: function (data) {
      var inv = this.inventory.details.find(d => d.id === this.idDetail)
      var disableSN = false
      if (data.canBarcode === true) {
        disableSN = false
      } else {
        inv.serial_number = null
        disableSN = true
      }
      inv.product_no = data.product_no
      inv.uom_id = data.uom_id
      inv.qty = 1
      inv.product = data.product_name
      inv.disableSN = disableSN
    },
    addLine: function () {
      var newID = Math.floor(Math.random() * (99999999 - 66666666) + 66666666)
      this.idDetail = newID
      var obj = {
        id: newID,
        transfer_no: null,
        product_no: null,
        qty: 1,
        uom_id: null,
        transfer_date: null,
        type: 'to',
        warehouse_no: this.inventory.warehouse_to,
        branch_no: null,
        serial_number: null,
        disableSN: false,
        state: 'create',
        company_to: this.inventory.company_to,
        company_origin: this.inventory.company_origin,
        amount: '0',
        uomList: [{
          id: null,
          name: null,
          ratio: '0',
          category: null
        }]
      }
      this.inventory.details.push(obj)
    },
    approveInventory: function () {
      axios.get(inventoryUrl + '/approve/' + this.inventory.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.backParent()
        })
        .catch(error => {
          console.log(error)
          this.$swal(
            'Error',
            '<pre>' + error.response + '</pre>',
            'error'
          )
        })
    },
    saveInventory: function () {
      axios.post(inventoryUrl + '/transfer', this.inventory, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Success', response.data.message, 'success')
          this.backParent()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.message, 'error')
          throw error
        })
    },
    updateInventory: function () {
      axios.put(inventoryUrl + '/transfer/' + this.inventory.id, this.inventory, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Success', response.data.message, 'success')
          this.backParent()
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    addBarcode: function (id) {
      this.idPDetail = id
      var pDetail = this.purchasing.details.find(d => d.id === id)
      var uom = this.uomList.find(d => d.id === pDetail.uom_id)
      var newUom = this.uomList.find(d => {
        if (d.type_id === uom.type_id && d.category_id === 3) {
          return d
        }
      })
      var ind = this.inventory.detail.find(d => d.id === null)
      /* eslint-disable */
      var newID = Math.floor(Math.random() * (9999999999 - 666666666666) + 666666666666)
      if (ind) {
        ind.id = newID,
        ind.product_no = pDetail.product_no
        ind.product = pDetail.product
        ind.uom_id = newUom.id
        ind.qty_done = 1
      } else {
        if (pDetail.canBarcode === false) {
          const inv = this.inventory.detail.filter(p => p.product_no === pDetail.product_no)
          if (inv.length < 1){
            var obj = {
              id: newID,
              inventory_no: null,
              qty_demand: null,
              qty_done: 1,
              serial_number: null,
              product_no: pDetail.product_no,
              product: pDetail.product,
              canBarcode: pDetail.canBarcode,
              warehouse_no: null,
              uom_id: newUom.id
            }
            // this.inventory.detail.push(obj)
          }
        } else {
          var obj = {
            id: newID,
            inventory_no: null,
            qty_demand: null,
            qty_done: 1,
            serial_number: null,
            product_no: pDetail.product_no,
            product: pDetail.product,
            canBarcode: pDetail.canBarcode,
            warehouse_no: null,
            uom_id: newUom.id
          }
          // this.inventory.detail.push(obj)
        }
      }
      this.product = {
        product_no: pDetail.product_no,
        uom_id: newUom.id
      }
    },
    backParent: function () {
      this.$emit('backClicked')
    },
    saveBarcode: function (value) {
      var pd = this.purchasing.details.find(d => d.id === value.idPDetail)
      pd.qty_done = value.qty_done
      console.log(value)
      console.log(pd)
    }
  }
}
</script>

<style>
  .flex {
    display: flex;
    flex-direction: row;
  }
</style>
